import type { RuntimeConfig } from "./types";

function fromEnvironment(): RuntimeConfig {
  const clientId = String(import.meta.env.VITE_CLIENT_ID || "");
  return {
    tenantId: String(import.meta.env.VITE_TENANT_ID || ""),
    clientId,
    apiBaseUrl: String(import.meta.env.VITE_API_BASE_URL || "http://localhost:7071/api").replace(/\/$/, ""),
    apiScope: String(import.meta.env.VITE_API_SCOPE || (clientId ? `api://${clientId}/access_as_user` : "")),
    demoMode: String(import.meta.env.VITE_DEMO_MODE || "").toLowerCase() === "true" || !clientId,
  };
}

export async function loadRuntimeConfig(): Promise<RuntimeConfig> {
  const fallback = fromEnvironment();
  // Explicit local preview only; production builds cannot override tenant auth this way.
  if (import.meta.env.DEV && import.meta.env.VITE_DEMO_MODE === "true") return fallback;
  try {
    const response = await fetch("/runtime-config.json", { cache: "no-store" });
    if (!response.ok) return fallback;
    const config = (await response.json()) as Partial<RuntimeConfig>;
    return {
      tenantId: config.tenantId || fallback.tenantId,
      clientId: config.clientId || fallback.clientId,
      apiBaseUrl: String(config.apiBaseUrl || fallback.apiBaseUrl).replace(/\/$/, ""),
      apiScope: config.apiScope || fallback.apiScope,
      demoMode: config.demoMode ?? fallback.demoMode,
    };
  } catch {
    return fallback;
  }
}
